import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  stepper: {
    background: 'transparent',
    marginBottom: '2rem',
    paddingLeft: 0,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    padding: theme.spacing(8),
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  notifyButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  summaryRow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  buttonSpinner: {
    color: 'rgba(0, 0, 0, 0.26)',
    marginRight: theme.spacing(2),
  },
}));

export default useStyles;
